module.exports = __webpack_public_path__ + "img/8.faf729d6.png";